// extracted by mini-css-extract-plugin
export default {"wrap":"Zn-z","fullWidth":"_n-z","items":"ao-z","featureCss":"bo-z","disabled":"co-z","imgCss":"do-z"};